import axios from "axios";
import React, { useState, useRef } from "react";
import { Send } from "lucide-react";
import { NotificationManager } from "react-notifications";

export default function Notified({ status }) {
  const [emails, setEmails] = useState('');
  const form = useRef();

  const handleSubmitEmailNotification = (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);

    axios.post('/notsendemail', formData)
      .then(resp => {
        console.log(resp.data);
        NotificationManager.success(
          resp.data.message,
          "Email",
          4000
        );
      })
      .catch(error => {
        NotificationManager.error(
          error.response.data.error,
          "Erreur",
          4000
        );
      });
  };

  const handleChangeEmail = (e) => {
    setEmails(e.target.value);
  };

  const renderFormGroup = (label, type, id, placeholder, rows, name) => (
    <div className="form-group">
      <label className="form-label" htmlFor={id}>{label}</label>
      {type === 'textarea' ? (
        <textarea className="form-control" name={name} id={id} aria-describedby="emailHelp" rows={rows} placeholder={placeholder}></textarea>
      ) : (
        <input type={type} className="form-control" name={name} id={id} aria-describedby="emailHelp" placeholder={placeholder} onChange={type === "email" ? handleChangeEmail : null} />
      )}
      <small id="emailHelp" className="form-text text-muted">{type === 'email' ? 'Séparer les adresses e-mail par des virgules.' : ''}</small>
    </div>
  );

  const renderFormContent = () => {
    switch (status) {
      case 'one':
        return (
          <>
            <form ref={form} onSubmit={handleSubmitEmailNotification}>
              <h4>Notifier par E-mail</h4>
              {renderFormGroup("E-mail", "email", "exampleInputEmail1", "Enter email", "user_email" , "user_email")}
              {renderFormGroup("Objet", "text", "emailSubject", "Enter subject", "user_objet", "user_objet")}
              {renderFormGroup("Contenu de l'e-mail", "textarea", "emailContent", "Contenu de votre e-mail", 4, "message")}
              <button className="btn btn-primary" type="submit">
                <Send size={20} strokeWidth={1.75} /> Envoyer
              </button>
            </form>
          </>
        );
      case 'two':
        return (
          <>
            <h4>Notifier par Téléphone</h4>
            {renderFormGroup("Téléphone", "number", "phoneInput", "Enter le numéro de téléphone")}
            {renderFormGroup("Contenu du message", "textarea", "phoneContent", "Contenu de votre message", 4)}
            <button type="submit" className="btn btn-primary disabled">Envoyer</button>
          </>
        );
      default:
        return (
          <>
            <h4>Notifier par les réseaux sociaux</h4>
            {renderFormGroup("Lien de profile", "url", "socialProfile", "Coller le lien")}
            {renderFormGroup("Contenu du message", "textarea", "socialContent", "Contenu de votre message", 4)}
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="checkbox" id="facebookCheckbox" value="Facebook" />
              <label className="form-check-label" htmlFor="facebookCheckbox">Facebook</label>
            </div>
            <div className="form-check form-check-inline">
              <input className="form-check-input" type="checkbox" id="linkedinCheckbox" value="Linkedin" />
              <label className="form-check-label" htmlFor="linkedinCheckbox">Linkedin</label>
            </div>
            <br /><br />
            <button type="submit" className="btn btn-primary disabled">Envoyer</button>
          </>
        );
    }
  };

  return (
    <div className="card-body collapse show">
      {renderFormContent()}
    </div>
  );
}
